<template>
  <div class="home-page-wrapper about-page-wrapper academic-list-wrapper">
    <div class="container">
      <ul class="academic-list">
        <li v-for="(item, index) in academicSpecialities" :key="item.id">
         {{index + 1}}.  {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import resourceNamePluralizer from "@/utils/resource-name-pluralizer";
import { mapGetters } from "vuex";

const STORE_KEY = "searchStore";

export default {
  name: "AcademicSpecialtiesList",
  computed: {
    ...mapGetters({
      academicSpecialities: `${STORE_KEY}/academicSpecialities`,
    }),
  },
  async mounted(){
    await this.$store.dispatch(`${STORE_KEY}/getSortedTaxonomy`, {
      storeKey: resourceNamePluralizer.get('academicSpeciality'),
      loadingKey: `${resourceNamePluralizer.get('academicSpeciality')}Loading`,
      type: 'Academic Specialities'
    });
      if(localStorage.getItem('user-permissions') != '"player"'){
          const newWindow = window.open(
          `${window.location.origin}/home`
        )
      }
  }
};
</script>

<style lang="scss">
.academic-list-wrapper{
  padding: 30px 0 30px 0;
}
.academic-list {
  li {
    margin: 15px 0 6px 0;
    border-bottom: 1px solid #ddd;
  }
}
</style>